import { useFormik } from "formik";
import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

interface NewTagModalFormProps {
  TagValidationSchema: any;
  onCreateNewTag: (tagDetails: any) => void;
}

const NewTagModalForm: React.FC<NewTagModalFormProps> = ({
  TagValidationSchema,
  onCreateNewTag,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
  };
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      appTagName: "",
    },
    validationSchema: TagValidationSchema,
    onSubmit: (values, { resetForm }) => {
      onCreateNewTag(values);
      resetForm();
      handleModalClose();
    },
  });


  return (
    <>
      
        <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
          Add New Tag
        </Button>
      
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{"Add New Tag"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="tag">
              <Form.Label>Tag</Form.Label>
              <Form.Control
                defaultValue={ ""}
                type="text"
                name="appTagName"
                onChange={formik.handleChange}
                isInvalid={!!(formik.touched.appTagName && formik.errors.appTagName)}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.appTagName}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>
            {"Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NewTagModalForm;
